import { Link } from "react-router-dom";
import { t } from "../../i18n";
import { PhoneField } from "./Controls";

export const ContactStep = ({ locale, account, buyer, setBuyer, emailValid, countryList, onContinue }) => {
  const set = (k, v) => setBuyer((b) => ({ ...b, [k]: v }));
  return (
    <section className="space-y-5" data-testid="checkout-contact">
      <div>
        <h1 className="font-display text-3xl text-ink">{t(locale, "contactTitle")}</h1>
        <p className="text-sm text-muted mt-2">{t(locale, "contactHelp")}</p>
      </div>
      {!account ? (
        <Link to={`/${locale}/account`} className="btn-ghost text-xs inline-block" data-testid="checkout-login-link">
          {t(locale, "haveAccount")}
        </Link>
      ) : null}
      <div className="space-y-1">
        <label className="smallcaps" htmlFor="buyer-email">{t(locale, "buyerEmail")}</label>
        <input id="buyer-email" data-testid="buyer-email" className="field" type="email" autoComplete="email"
               enterKeyHint="next" placeholder="you@example.com" value={buyer.buyer_email}
               onChange={(e) => set("buyer_email", e.target.value)} />
        {buyer.buyer_email && !emailValid ? (
          <p className="text-danger text-xs" data-testid="buyer-email-error">{t(locale, "requiredEmail")}</p>
        ) : null}
      </div>
      <div className="grid sm:grid-cols-2 gap-4 items-end">
        <div className="space-y-1">
          <label className="smallcaps" htmlFor="buyer-phone">{t(locale, "buyerPhone")}</label>
          <PhoneField dialTestid="buyer-phone-flag" dialLabel={t(locale, "country")} list={countryList}
                      country={buyer.buyer_country} onCountry={(v) => set("buyer_country", v)}
                      inputProps={{ id: "buyer-phone", "data-testid": "buyer-phone", autoComplete: "tel",
                                    value: buyer.buyer_phone, onChange: (e) => set("buyer_phone", e.target.value) }} />
        </div>
        <div className="space-y-1">
          <label className="smallcaps" htmlFor="buyer-country">{t(locale, "country")}</label>
          <select id="buyer-country" data-testid="buyer-country" className="field" value={buyer.buyer_country}
                  onChange={(e) => set("buyer_country", e.target.value)}>
            {countryList.map((c) => <option key={c.code} value={c.code}>{`${c.flag} ${c.name}`}</option>)}
          </select>
        </div>
      </div>
      <label className="flex items-center gap-2 text-sm text-charcoal">
        <input type="checkbox" data-testid="whatsapp-optin" checked={buyer.whatsapp_opt_in}
               onChange={(e) => set("whatsapp_opt_in", e.target.checked)} />
        {t(locale, "whatsappUpdates")}
      </label>
      <label className="flex items-start gap-2 text-sm text-charcoal">
        <input type="checkbox" className="mt-1" data-testid="newsletter-optin" checked={buyer.newsletter_opt_in}
               onChange={(e) => set("newsletter_opt_in", e.target.checked)} />
        {t(locale, "newsletterOptIn")}
      </label>
      <button data-testid="checkout-continue-1" className="btn-primary w-full sm:w-auto" disabled={!emailValid}
              onClick={onContinue}>
        {t(locale, "continue")}
      </button>
    </section>
  );
};
